//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { generalRightArrow } from '@tidal/styles-icons';

export default {
    props: {
        contentClass: {
            type: String,
            default: '',
        },
    },
    computed: {
        icons() {
            return {
                generalRightArrow,
            };
        },
        /** @return {TIDAL.MenuItem[]} */
        visibleItems() {
            return this.$navigation.items.filter(item => item.isHidden === undefined || !item.isHidden());
        },
    },
    methods: {
        /**
         * @param {MouseEvent} event
         * @param {TIDAL.MenuItem} item
         */
        handleClick(event, item) {
            if (item.external) {
                return;
            }

            event.preventDefault();

            if (item.clickHandler) {
                item.clickHandler();
                return;
            }

            this.$router.push(item.href, () => {}, () => this.$emit('navigation-aborted'));
        },
        /**
         * @param {TIDAL.MenuItem} item
         * @return {boolean}
         */
        isItemSelected(item) {
            return this.$navigation.currentItem === item;
        },
    },
};
